import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import useSeo from "@/hooks/useSeo";

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: "页面不存在 - 51黑料网",
    description: "你访问的页面不存在或已被移动，请返回51黑料网首页浏览最新爆料资讯。",
    keywords: "51黑料网,页面不存在",
  });

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1 flex items-center">
        <div className="max-w-portal mx-auto px-4 md:px-6 py-16 md:py-24 w-full">
          <div className="relative rounded-lg border border-background-200 bg-background-100 px-6 py-14 md:py-20 text-center overflow-hidden">
            <p className="font-heading text-[80px] md:text-[150px] font-black leading-none text-background-300 select-none">
              404
            </p>
            <h1 className="mt-2 font-heading text-2xl md:text-3xl font-black text-foreground-950">
              这个页面好像被撤下了
            </h1>
            <p className="mt-2 text-sm text-foreground-500">
              你访问的地址 <span className="font-label text-foreground-700">{location.pathname}</span> 不存在，
              可能已经被移动。
            </p>
            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-2">
              <Link
                to="/"
                className="w-full sm:w-auto h-10 px-5 inline-flex items-center justify-center rounded-md bg-primary-600 text-background-50 text-sm hover:bg-primary-700 transition-colors whitespace-nowrap"
              >
                返回首页
              </Link>
              <Link
                to="/search"
                className="w-full sm:w-auto h-10 px-5 inline-flex items-center justify-center rounded-md border border-background-300 bg-background-50 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                搜索爆料
              </Link>
            </div>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}